import React, { useState } from 'react';

const aiFeatures = [
  {
    iconColor: '#E8611A',
    iconBg: 'rgba(232,97,26,0.12)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M12 2a4 4 0 014 4v1h1a3 3 0 013 3v2a3 3 0 01-3 3h-1v1a4 4 0 01-8 0v-1H7a3 3 0 01-3-3v-2a3 3 0 013-3h1V6a4 4 0 014-4z" />
        <circle cx="9" cy="10" r="1" fill="#E8611A" stroke="none" />
        <circle cx="15" cy="10" r="1" fill="#E8611A" stroke="none" />
        <path d="M9 14s1 1.5 3 1.5 3-1.5 3-1.5" />
      </svg>
    ),
    title: 'Chatbots & Assistants IA',
    description:
      "Nous concevons des agents conversationnels intelligents capables de comprendre le langage naturel, d'automatiser le support client et d'améliorer l'expérience utilisateur 24h/24.",
  },
  {
    iconColor: '#7c3aed',
    iconBg: 'rgba(124,58,237,0.12)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18" />
      </svg>
    ),
    title: 'Analyse de Données & ML',
    description:
      "Nos solutions de Machine Learning extraient des insights précieux de vos données pour vous aider à prendre des décisions stratégiques éclairées et anticiper les tendances.",
  },
  {
    iconColor: '#0ea5e9',
    iconBg: 'rgba(14,165,233,0.12)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
        <path d="M7 8l3 3-3 3M13 14h4" />
      </svg>
    ),
    title: 'Automatisation Intelligente',
    description:
      "Automatisez vos processus métier grâce à l'IA : traitement de documents, workflows adaptatifs, et intégration transparente dans vos systèmes existants.",
  },
  {
    iconColor: '#16a34a',
    iconBg: 'rgba(22,163,74,0.12)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
    title: 'Vision par Ordinateur',
    description:
      "Détection d'objets, analyse d'images, OCR et surveillance intelligente : nos modèles de vision permettent à vos applications de voir et comprendre le monde visuel.",
  },
];

const stats = [
  { value: '10x', label: 'Productivité boostée' },
  { value: '98%', label: 'Précision des modèles' },
  { value: '24/7', label: 'Disponibilité IA' },
  { value: '50+', label: 'Projets livrés' },
];

function AIFeatureCard({ item }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? '#ffffff' : 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(14px)',
        border: hovered ? `1px solid ${item.iconColor}40` : '1px solid rgba(0,0,0,0.06)',
        borderRadius: 20,
        padding: '28px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        transition: 'all .28s cubic-bezier(.4,0,.2,1)',
        transform: hovered ? 'translateY(-6px) scale(1.015)' : 'none',
        boxShadow: hovered
          ? `0 24px 48px rgba(0,0,0,0.13), 0 0 0 1px ${item.iconColor}25`
          : '0 4px 20px rgba(0,0,0,0.07)',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'default',
      }}
    >
      {hovered && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 3,
          background: `linear-gradient(90deg, transparent, ${item.iconColor}, transparent)`,
          borderRadius: '20px 20px 0 0',
        }} />
      )}
      <div style={{
        width: 56, height: 56, borderRadius: 16,
        background: item.iconBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
        boxShadow: `0 4px 14px ${item.iconColor}20`,
      }}>
        {item.icon}
      </div>
      <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>
        {item.title}
      </h3>
      <p style={{ fontSize: '0.875rem', color: '#64748b', lineHeight: 1.75, margin: 0, flex: 1 }}>
        {item.description}
      </p>
    </div>
  );
}

const AISection = () => {
  return (
    <section style={{
      background: '#F8F7F4',
      padding: '36px 0 32px',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
      borderBottom: '1px solid rgba(0,0,0,0.07)',
    }}>


      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '6px 18px', borderRadius: 999,
            border: '1px solid rgba(0,0,0,0.1)',
            background: 'rgba(0,0,0,0.04)',
            marginBottom: 18,
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#94a3b8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Intelligence Artificielle</span>
          </div>

          <h2 style={{
            fontSize: 'clamp(1.8rem, 4vw, 2.6rem)', fontWeight: 800,
            color: '#1e293b', margin: '0 0 14px', lineHeight: 1.2,
          }}>
            L'IA au service de votre{' '}
            <span style={{
              background: 'linear-gradient(90deg, #E8611A, #d4501a)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>croissance</span>
          </h2>

          <div style={{ width: 48, height: 3, background: 'linear-gradient(90deg, #E8611A, #7c3aed)', borderRadius: 4, margin: '0 auto 18px' }} />

          <p style={{
            color: '#64748b', maxWidth: 620, margin: '0 auto',
            fontSize: '0.95rem', lineHeight: 1.75,
          }}>
            Aydees intègre les dernières avancées en intelligence artificielle dans vos projets :
            automatisation, analyse prédictive, traitement du langage naturel et vision par ordinateur
            pour transformer votre activité.
          </p>
        </div>

        {/* Feature cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 20,
          marginBottom: 32,
        }}>
          {aiFeatures.map((item, i) => <AIFeatureCard key={i} item={item} />)}
        </div>

        {/* Stats bar */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: 1,
          background: 'rgba(0,0,0,0.03)',
          border: '1px solid rgba(0,0,0,0.07)',
          borderRadius: 20,
          overflow: 'hidden',
        }}>
          {stats.map((s, i) => (
            <div key={i} style={{
              padding: '28px 20px',
              textAlign: 'center',
              borderRight: i < stats.length - 1 ? '1px solid rgba(0,0,0,0.06)' : 'none',
              background: 'transparent',
            }}>
              <div style={{
                fontSize: 'clamp(1.8rem, 3vw, 2.4rem)',
                fontWeight: 800,
                background: 'linear-gradient(90deg, #E8611A, #d4501a)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                lineHeight: 1,
                marginBottom: 8,
              }}>
                {s.value}
              </div>
              <div style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 28 }}>
          <a href="/services" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            padding: '14px 32px', borderRadius: 999,
            background: 'linear-gradient(135deg, #E8611A, #d4501a)',
            color: '#fff', fontWeight: 700, fontSize: '0.95rem',
            textDecoration: 'none',
            boxShadow: '0 8px 30px rgba(232,97,26,0.45)',
            transition: 'transform .2s, box-shadow .2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 14px 40px rgba(232,97,26,0.55)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(232,97,26,0.45)'; }}
          >
            Découvrir nos solutions IA
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
        </div>

      </div>
    </section>
  );
};

export default AISection;
